import { Component, OnInit, ViewChild } from '@angular/core';
import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import { Color, Label, BaseChartDirective } from 'ng2-charts';
import { ReportService } from '../../_service/report.service';
import { SharedService } from '../../_service/shared.service';
import { LeadsService } from '../../_service/leads.service';

@Component({
  selector: 'app-yearly-report',
  templateUrl: './yearly-report.component.html',
  styleUrls: ['./yearly-report.component.css']
})
export class YearlyReportComponent implements OnInit {

  @ViewChild(BaseChartDirective) chart: BaseChartDirective;
  @ViewChild(BaseChartDirective) Opdchart: BaseChartDirective;
  @ViewChild(BaseChartDirective) Ipdchart: BaseChartDirective;
  
  barChartType: ChartType = 'bar';
  color:Color[] = [{backgroundColor:'#0F74B2'}];
  barChartLegend = true;
  barChartPlugins = [];
  barChartOptions: ChartOptions = {
    responsive: true,
  };
  barChartLabels: Label[] = [];
  barChartData: ChartDataSets[] = [
    { data: [], label: 'Lead Count' }
  ];

  barChartLabelsOpd: Label[] = [];
  barChartDataOpd: ChartDataSets[] = [
    { data: [], label: 'Opd Count' }
  ];
  barChartLabelsIpd: Label[] = [];
  barChartDataIpd: ChartDataSets[] = [
    { data: [], label: 'Ipd Count' }
  ];
  duration = 'all';circle:string='';circles:any=[];myrole:string='';
  constructor(private leadapi:LeadsService,private reportapi:ReportService,private sharedapi:SharedService) { }

  ngOnInit(): void 
  {
      this.sharedapi.getRole()
      .subscribe((item:string) => {this.myrole=item;});
      this.myrole = localStorage.getItem('role');
      if(this.myrole=='1')
      {
          this.getcircle();
      }
    this.getLeadReport();
    this.getOpdReport();
    this.getIpdReport();
  }

    async getLeadReport()
    {
      let qString = 'duration='+this.duration+'&circle='+this.circle;
        await this.reportapi.getLeadYearlyreport(qString).subscribe(
        (data:any) => {
            if(data && data.status)
            {
              this.chart.chart.config.data.labels = data.label;
              this.chart.chart.data.datasets[0].data = data.data;
              this.chart.chart.update()
            }else{
              this.sharedapi.presentToast('Error Occured');
            }
        },
        error => {
            this.sharedapi.checkError(error);
        });
    }

    async getOpdReport()
    {
        let qString = 'duration='+this.duration+'&circle='+this.circle;
        await this.reportapi.getOpdYearlyreport(qString).subscribe(
        (data:any) => {
            if(data && data.status)
            {
              this.barChartLabelsOpd = data.label;
              this.barChartDataOpd[0].data = data.data; 
            }else{
              this.sharedapi.presentToast('Error Occured');
            }
        },
        error => {
            this.sharedapi.checkError(error);
        });
    }

    async getIpdReport()
    {
      let qString = 'duration='+this.duration+'&circle='+this.circle;
        await this.reportapi.getIpdYearlyreport(qString).subscribe(
        (data:any) => {
            if(data && data.status)
            {
              this.barChartLabelsIpd = data.label;
              this.barChartDataIpd[0].data = data.data; 
            }else{
              this.sharedapi.presentToast('Error Occured');
            }
        },
        error => {
            this.sharedapi.checkError(error);
        });
    }

    async getcircle()
    {
        await this.leadapi.getcircles().subscribe((data:any) => {
            if(data.status)
            {
                this.circles = data.data;
            }else{
                this.circles = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

}
